<template>
	<UPageSection
		:id="`page-section-${areaName}`"
		orientation="horizontal"
		:ui="{
			leading: 'text-2xl sm:text-3xl lg:text-4xl text-pretty tracking-tight text-primary mb-1',
			title: 'text-2xl sm:text-3xl lg:text-4xl text-pretty tracking-tight text-highlighted',
			container: 'max-w-5xl sm:py-8 lg:my-0 mb-8'
		}"
	>
		<template #leading>
			<motion.span
				:while-in-view="{ opacity: 1 }"
				:initial="{ opacity: 0 }"
				:transition="{ delay: 0.4 }"
				:in-view-options="{ once: true }"
				class="text-primary font-semibold text-4xl"
			>
				<span>
					{{ $t('service-area.cta.title', { areaName }) }}
				</span>
			</motion.span>
		</template>
		<template #title>
			<motion.span
				:while-in-view="{ opacity: 1 }"
				:initial="{ opacity: 0 }"
				:transition="{ delay: 0.4 }"
				:in-view-options="{ once: true }"
				class="text-highlighted text-4xl font-semibold"
			>
				<span>
					{{ $t('service-area.cta.subtitle') }}
				</span>
			</motion.span>
		</template>
		<template #description>
			<motion.p
				:while-in-view="{ opacity: 1, transform: 'translateX(0px)' }"
				:initial="{ opacity: 0, x: 10 }"
				:transition="{ duration: 0.4, delay: 0.5 }"
				class="pb-4"
				:in-view-options="{ once: true }"
			>
				<span v-html="$t('service-area.cta.p1', { areaName })" />
			</motion.p>
			<motion.p
				:while-in-view="{ opacity: 1, transform: 'translateX(0px)' }"
				:initial="{ opacity: 0, x: 10 }"
				:transition="{ duration: 0.4, delay: 0.6 }"
				class="pb-4"
				:in-view-options="{ once: true }"
			>
				<span v-html="$t('service-area.cta.p2', { areaCity })" />
			</motion.p>
			<ServiceAreasSpeeds :area-name="areaName" />
			<slot name="cta">
				<Motion
					as-child
					:while-in-view="{ opacity: 1, transform: 'translateY(0px)' }"
					:initial="{ opacity: 0, transform: 'translateY(25px)' }"
					:transition="{ type: 'spring', bounce: 0.5, duration: 1, delay: 0.1 }"
					:in-view-options="{ once: true }"
					class="will-change-transform w-full flex flex-col items-center justify-center"
				>
					<div>
						<p class="text-highlighted font-semibold text-2xl text-center">
							{{ $t('service-area.cta.button-heading') }}
						</p>
						<UButton
							:to="localePath('get-fiber')"
							:label="$t('service-area.cta.button-text')"
							size="xl"
							class="mt-6 uppercase w-full sm:w-64"
						/>
					</div>
				</Motion>
			</slot>
		</template>
	</UPageSection>
</template>

<script setup lang="ts">
import {
	motion, Motion
} from 'motion-v'

const localePath = useLocalePath()

defineProps({
	areaName: {
		type: String,
		required: true
	},
	areaCity: {
		type: String,
		required: true
	}
})
</script>
